import { render, staticRenderFns } from "./SearchQuery.vue?vue&type=template&id=566234c8&scoped=true"
import script from "./SearchQuery.vue?vue&type=script&lang=js"
export * from "./SearchQuery.vue?vue&type=script&lang=js"
import style0 from "./SearchQuery.vue?vue&type=style&index=0&id=566234c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566234c8",
  null
  
)

export default component.exports